module.exports = __webpack_public_path__ + "static/media/door0302.0844ac0a.jpg";